export const getInternalValue = (value) => {
    if (value.includes(undefined)) {
        return [];
    }
    return value;
};
